import BaseModel from "./BaseModel";

const CurrencyModel = BaseModel.extend({

});

export default CurrencyModel;